import { useQuery } from '@hooks/reactQuery';

import { getMavenirConfigVersions } from '@api/dataSources';

import { optionsFormattedWithArray } from '@utils/formatter';

import { TMavenirVersionsFilter } from '@interfaces/cmModule/dataSources';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { MAVENIR_CONFIG_VERSIONS } from '@constants/queryKeys';

interface IMavenirConfigVersionOptionsReturnType {
	versionOptions: TSelectOption<string>[];
	isLoadingMavenirConfigs: boolean;
	latestVersion?: TSelectOption<string>;
}

const useQueryMavenirConfigVersionOptions = (): IMavenirConfigVersionOptionsReturnType => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<TMavenirVersionsFilter, TMavenirVersionsFilter<TSelectOption<string>>>({
		queryKey: [MAVENIR_CONFIG_VERSIONS],
		queryFn: getMavenirConfigVersions,
		select: (items) => {
			const { versions, latestVersion } = items;

			const sortedItems = versions.sort((a, b) => b.localeCompare(a));

			return { latestVersion, versions: optionsFormattedWithArray(sortedItems) };
		},
		...refetchOptions,
	});

	const { latestVersion, versions } = data || {};

	return {
		versionOptions: versions || [],
		latestVersion: latestVersion ? optionsFormattedWithArray([latestVersion])[0] : undefined,
		isLoadingMavenirConfigs: isLoading || isFetching,
	};
};

export default useQueryMavenirConfigVersionOptions;
